/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import { TealiumProvider } from "@nib/tealium-universal-tag/react";
import { GatsbyBrowser } from "gatsby";
import Cookies from "js-cookie";
import React from "react";

import { AppProviders } from "src/components/Context/AppProviders";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => {
  return <AppProviders>{element}</AppProviders>;
};

/**
 *
 * `wrapPageElement` element is required for `<TealiumProvider>` as `wrapRootElement` results in duplicate event listeners.
 *  Use `wrapRootElement` for all other context providers: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/#wrapRootElement
 */
export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({ element }) => {
  return (
    <TealiumProvider
      account="nib"
      profile="main"
      environment={process.env.GATSBY_ENVIRONMENT as string}
    >
      {element}
    </TealiumProvider>
  );
};

/**
 *
 * Set app hops link URL Search Parameters to cookies before routing
 */
export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  const searchParams = new URLSearchParams(window.location.search);

  const referrer = searchParams.get("referrer");
  if (referrer && ["androidMemberApp", "iosMemberApp"].includes(referrer)) {
    Cookies.set("isMobileApp", "true");
  }
};
